import { logUsage } from 'owa-analytics';
import AttachmentId from 'owa-service/lib/contract/AttachmentId';
import { action } from 'satcheljs/lib/legacy';
import AttachmentWellViewState from '../schema/AttachmentWellViewState';

export default action('changeTotalClassicAttachmentSize')(function changeTotalClassicAttachmentSize(
    attachmentWell: AttachmentWellViewState,
    offset: number,
    attachmentId: AttachmentId
) {
    attachmentWell.totalClassicAttachmentSize += offset;
    logUsage(
        'changeTotalClassicAttachmentSize',
        {
            composeId: attachmentWell.composeId,
            attachmentId: attachmentId !== null ? attachmentId.Id : null,
            maxAttachmentSize: attachmentWell.maxTotalClassicAttachmentSize,
            totalAttachmentSize: attachmentWell.totalClassicAttachmentSize,
        },
        { ring: 'Dogfood' } // VSTO: 56734 remove this after a certain period when no issue within this area
    );
});
